import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { OidcProvider } from 'redux-oidc';
import { Redirect, Route, Switch } from 'react-router-dom';
import store, { persistor,history } from '../modules/store/index';
import { ConnectedRouter } from "connected-react-router";
import track from "react-tracking";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

import userManager from '../modules/oidc/UserManager';
import { TrackedLoginPage } from '../pages/Login/Login';
import CallbackPage from '../app/auth/Callback';
import SignOutCallbackPage from '../app/auth/Signout';
import { SecuredRoute } from "../modules/guards/SecuredRoute";
import { App } from "../app";
import { Banner } from "../app/banner";
import guards from "../modules/guards/index";



import "./root.scss";
import {PersistGate} from "redux-persist/integration/react";

const EOL_BANNER_DISMISSED_KEY = "insights-eol-banner-dismissed";

const Root: React.FC = () => {
    const [showEolBanner, setShowEolBanner] = useState(
        sessionStorage.getItem(EOL_BANNER_DISMISSED_KEY) !== "true"
    );

    const dismissEolBanner = () => {
        sessionStorage.setItem(EOL_BANNER_DISMISSED_KEY, "true");
        setShowEolBanner(false);
    };

    return <Provider store={store}>
        <PersistGate loading={null} persistor={ persistor }>
            <OidcProvider store={store} userManager={userManager}>
                <ConnectedRouter history={history}>
                    <>
                        <Banner
                            Icon={() => <FontAwesomeIcon icon={faExclamationTriangle} />}
                            message={<p>Insights has reached the end of the road and will be turned off on the 30th of November 2026. <a href="https://help.blackpearlmail.com/en/articles/26792">Learn more.</a></p>}
                            canDismiss={true}
                            onDismiss={dismissEolBanner}
                            showAlert={showEolBanner}
                        />
                        <Switch>
                            <SecuredRoute exact guards={[guards.isLoggedOut()]} failureLocation="/dashboard" path="/login" component={TrackedLoginPage}/>
                            <Route exact path="/callback" component={CallbackPage}/>
                            <Route exact path="/sign-out" component={SignOutCallbackPage}/>
                            <Route  path="/" component={App}/>
                            <Redirect from="*" to="/login"/>
                        </Switch>
                    </>
                </ConnectedRouter>
            </OidcProvider>
        </PersistGate>
    </Provider>;
};

export default track({}, { process: (ownTrackingData: any) => ownTrackingData.page ? {event: 'pageview'} : null })(Root);
